module.exports = __webpack_public_path__ + "static/media/vegitables_74.5912d883.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_74.csv
// module id = 662
// module chunks = 0